import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { videoRoomTokenAtom } from '../../../video-sdk/core/room/state';

export function useClearAdmissionStateCallback() {
  const setVideoRoomToken = useSetAtom(videoRoomTokenAtom);

  return useCallback(() => {
    setVideoRoomToken(undefined);
  }, [setVideoRoomToken]);
}
